import { gql } from 'graphql.macro';

export const getPdfTemplate = gql`
    query pdfTemplate($labId: MongoDbObjectId!, $templateName: String!) {
        pdfTemplate(labId: $labId, templateName: $templateName) {
            _id
            templateName
            htmlContent
            enabled
            lab
        }
    }
`;
